import axios from "@/libs/api.request";
// 获取应收报表列表
export const getRefund = params => {
  return axios.request({
    url: "/report/cod/refund",
    method: "get",
    params
  });
};
